<template>
    <div id="contenedor-contratos-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'ContratosMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
